import React from 'react';
import NavBar from '../components/NavBar';
import GameCard from '../components/GameCard';
import './Games.css';
import { Helmet } from 'react-helmet-async';

function LogicGames() {
  const games = [
    {
      id: 'dailylogicpuzzles',
      title: 'Daily Logic Puzzles',
      description: 'A fresh set of bite-sized logic puzzles to keep your brain sharp. Come back daily for a new challenge!',
      imageUrl: '/assets/logos/dailylogicpuzzles_logo.webp',
      link: '/play/dailylogicpuzzles',
      infoLink: '/games/daily-logic-puzzles'
    },
    {
      id: 'foxhedge',
      title: 'Fox Hedge',
      description: 'Plant hedges to pen the fox in the best meadow you can. Fit in mushrooms, keep out the hens and beat par.',
      imageUrl: '/assets/images/gameplay/fox-hedge-384.webp',
      link: '/play/foxhedge',
      infoLink: '/games/fox-hedge'
    },
    {
      id: 'crowns',
      title: 'Crowns',
      description: 'Place one crown in every row, column and color region, with no two crowns touching. A new daily puzzle plus unlimited play.',
      imageUrl: '/assets/logos/crowns_logo_256.webp',
      link: '/play/crowns',
      infoLink: '/games/crowns'
    },
    {
      id: 'binarysudokuplus',
      title: 'Binary Sudoku+',
      description: 'A challenging puzzle game where you create perfect symmetry by placing tiles strategically on the board. Test your spatial reasoning and pattern recognition skills!',
      imageUrl: '/assets/logos/symmetrix_logo.webp',
      link: '/play/binarysudoku',
      infoLink: '/games/binary-sudoku-plus'
    },
    {
      id: 'aquarium',
      title: 'Aquarium',
      description: 'Fill the aquariums with the right amount of water in this unique logic puzzle. Use the numbers as clues to determine the water levels in each container.',
      imageUrl: '/assets/logos/aqua_logo.webp',
      link: '/play/aquarium',
      infoLink: '/games/aquarium'
    },
    {
      id: 'palettepath',
      title: 'Color Flood: Logic Puzzle',
      description: 'A colorful puzzle game where you connect matching colors while filling the entire board. Create beautiful patterns while exercising your logical thinking!',
      imageUrl: '/assets/logos/palettepath_logo.png',
      link: '/play/palettepath',
      infoLink: '/games/palette-path'
    },
    {
      id: 'dotstream',
      title: 'Dot Stream',
      description: 'A new and exciting game where you connect dots to create patterns and solve puzzles. Test your problem-solving skills and creativity!',
      imageUrl: '/assets/logos/dotstream_logo.webp',
      link: '/play/dotstream',
      infoLink: '/games/dot-stream'
    },
    {
      id: 'nonograms',
      title: 'Nonograms',
      description: 'Reveal hidden pictures by filling cells based on row and column number clues. Also known as paint-by-number logic, these picture logic puzzles are solved through pure deduction.',
      imageUrl: '/nonograms/icons/Icon-512.png',
      link: '/play/nonograms',
      infoLink: '/games/nonograms'
    },
    {
      id: 'calcudoku',
      title: 'Calcudoku',
      description: 'Combine arithmetic with logic! Fill the grid so each row and column contains every number, while satisfying math cage constraints using +, \u2212, \u00d7, and \u00f7.',
      imageUrl: '/calcudoku/icons/Icon-512.png',
      link: '/play/calcudoku',
      infoLink: '/games/calcudoku'
    },
    {
      id: 'sudoku',
      title: 'Sudoku',
      description: 'The classic number puzzle. Fill the 9x9 grid so that each column, each row, and each of the nine 3x3 subgrids contain all of the digits from 1 to 9.',
      imageUrl: '/assets/logos/sudoku_logo.webp',
      link: '/play/sudoku',
      infoLink: '/games/sudoku'
    },
    {
      id: 'sliderpuzzle',
      title: 'Slider Puzzle',
      description: 'Arrange the tiles in numerical order by sliding them into the empty space. A classic test of logic and planning!',
      imageUrl: '/sliderpuzzle/assets/logo.png',
      link: '/play/sliderpuzzle',
      infoLink: '/games/slider-puzzle'
    },
    {
      id: 'numbermerge',
      title: 'Number Merge',
      description: 'Combine matching numbered tiles to create higher numbers. Strategize your moves to achieve the highest score possible!',
      imageUrl: '/numbermerge/assets/logo.png',
      link: '/play/numbermerge',
      infoLink: '/games/number-merge'
    },
    {
      id: 'blockmerge',
      title: 'Block Merge',
      description: 'Merge blocks of the same color and number to clear the board and score points. Plan your merges carefully!',
      imageUrl: '/blockmerge/assets/logo.png',
      link: '/play/blockmerge',
      infoLink: '/games/block-merge'
    },
    {
      id: 'minefinder',
      title: 'Mine Finder',
      description: 'A no-guess mine-finding logic puzzle! Use number clues to deduce where mines are hidden and clear the board without detonating any.',
      imageUrl: '/minefinder/icons/Icon-512.png',
      link: '/play/minefinder',
      infoLink: '/games/mine-finder'
    },
    {
      id: 'tents',
      title: 'Tent Logic',
      description: 'Place tents next to trees on the grid using row and column clues. Each tree gets exactly one tent, and no two tents touch - even diagonally!',
      imageUrl: '/tents/icons/Icon-512.png',
      link: '/play/tents',
      infoLink: '/games/tent-logic'
    },
    {
      id: 'colorlinks',
      title: 'Color Links',
      description: 'Connect matching colors to fill the grid! Draw paths between pairs of colored dots without crossing lines or leaving empty cells.',
      imageUrl: '/assets/logos/colorlinks_logo.svg',
      link: '/play/colorlinks',
      infoLink: '/games/color-links'
    },
    {
      id: 'cryptograms',
      title: 'Cryptograms',
      description: 'Decode famous quotes by cracking the substitution cipher. Each letter stands for another - figure out the pattern to reveal the hidden message!',
      imageUrl: '/cryptograms/icons/Icon-512.png',
      link: '/play/cryptograms',
      infoLink: '/games/cryptograms'
    },
    {
      id: 'futoshiki',
      title: 'Futoshiki',
      description: 'Fill the grid with numbers following greater-than and less-than clues between cells. Each row and column contains every number exactly once.',
      imageUrl: '/assets/logos/futoshiki_logo.svg',
      link: '/play/futoshiki',
      infoLink: '/games/futoshiki'
    },
    {
      id: 'galaxies',
      title: 'Galaxies',
      description: 'Divide the grid into regions, each with perfect 180-degree rotational symmetry around its center dot. A beautiful spatial reasoning challenge!',
      imageUrl: '/assets/logos/galaxies_logo.svg',
      link: '/play/galaxies',
      infoLink: '/games/galaxies'
    },
    {
      id: 'kurodoku',
      title: 'Kurodoku',
      description: 'Shade cells black or white using number clues that show how many white cells are visible in each direction. Keep all white cells connected!',
      imageUrl: '/assets/logos/kurodoku_logo.svg',
      link: '/play/kurodoku',
      infoLink: '/games/kurodoku'
    },
    {
      id: 'logicgridpuzzles',
      title: 'Logic Grid Puzzles',
      description: 'Classic zebra-puzzle riddles! Use clues to figure out which items match across multiple categories using an elimination grid.',
      imageUrl: '/logicgridpuzzles/icons/Icon-512.png',
      link: '/play/logicgridpuzzles',
      infoLink: '/games/logic-grid-puzzles'
    },
    {
      id: 'mosaic',
      title: 'Mosaic',
      description: 'Fill cells so each number counts the filled cells in its 3x3 neighborhood, and a hidden picture appears. Like Mine Finder meets picture puzzles!',
      imageUrl: '/mosaic/icons/Icon-512.png',
      link: '/play/mosaic',
      infoLink: '/games/mosaic'
    },
    {
      id: 'rectangles',
      title: 'Rectangles',
      description: 'Divide the grid into rectangles so each one holds exactly one number, and that number is its area. 1,000 puzzles plus a daily board.',
      imageUrl: '/rectangles/icons/Icon-512.png',
      link: '/play/rectangles',
      infoLink: '/games/rectangles'
    },
    {
      id: 'pipes',
      title: 'Pipes',
      description: 'Rotate pipe pieces to connect them all into one network with no loose ends. A classic connection puzzle that tests your spatial reasoning!',
      imageUrl: '/assets/logos/pipes_logo.svg',
      link: '/play/pipes',
      infoLink: '/games/pipes'
    },
    {
      id: 'renzoku',
      title: 'Renzoku',
      description: 'Fill the grid with numbers where dots between cells mean those numbers are consecutive. No dot means they are not. Pure logical deduction!',
      imageUrl: '/assets/logos/renzoku_logo.svg',
      link: '/play/renzoku',
      infoLink: '/games/renzoku'
    },
    {
      id: 'slant',
      title: 'Slant',
      description: 'Place a diagonal line in every cell. Numbers at intersections tell you how many lines meet there. No closed loops allowed!',
      imageUrl: '/assets/logos/slant_logo.svg',
      link: '/play/slant',
      infoLink: '/games/slant'
    },
    {
      id: 'yinyang',
      title: 'Yin-Yang',
      description: 'Fill every cell with a black or white circle. Both colors must form one connected group, and no 2x2 area can be all the same color.',
      imageUrl: '/assets/logos/yinyang_logo.svg',
      link: '/play/yinyang',
      infoLink: '/games/yin-yang'
    },
    {
      id: 'skyscrapers',
      title: 'Skyscrapers',
      description: 'Place buildings of varying heights so each row and column contains every height exactly once. Use visibility clues from the edges to determine placement!',
      imageUrl: '/assets/logos/skyscrapers_logo.svg',
      link: '/play/skyscrapers',
      infoLink: '/games/skyscrapers'
    },
    {
      id: 'thermometers',
      title: 'Thermometers',
      description: 'Fill thermometers to the right level using row and column clues. Each thermometer fills from its bulb - figure out how much mercury to add!',
      imageUrl: '/assets/logos/thermometers_logo.svg',
      link: '/play/thermometers',
      infoLink: '/games/thermometers'
    },
    {
      id: 'dominosa',
      title: 'Domino Puzzle',
      description: 'Place every domino so each colored region keeps its rule, or split a number grid into a full set of dominoes. Three new daily puzzles every day!',
      imageUrl: '/dominosa/icons/Icon-512.png',
      link: '/play/dominosa',
      infoLink: '/games/dominosa'
    },
    {
      id: 'norinori',
      title: 'NoriNori',
      description: 'Shade exactly two cells in each region to form dominoes. No two shaded areas can touch - even diagonally!',
      imageUrl: '/assets/logos/norinori_logo.svg',
      link: '/play/norinori',
      infoLink: '/games/norinori'
    },
    {
      id: 'lits',
      title: 'LITS',
      description: 'Place one tetromino (L, I, T, or S) in each region. Shaded cells must connect, but no 2x2 block can be fully shaded and identical shapes can\'t touch!',
      imageUrl: '/assets/logos/lits_logo.svg',
      link: '/play/lits',
      infoLink: '/games/lits'
    },
    {
      id: 'butterflymahjong',
      title: 'Butterfly Tiles',
      description: 'Match pairs of beautiful butterfly tiles in this relaxing mahjong solitaire game. Clear the board by finding and connecting matching pairs. Features zen and arcade modes!',
      imageUrl: '/assets/logos/butterflymahjong_logo.png',
      link: '/play/butterflymahjong',
      infoLink: '/games/butterfly-tiles'
    }
  ];

  const itemListSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    'name': 'Free Online Logic Puzzle Games',
    'itemListElement': games.map((game, i) => ({
      '@type': 'ListItem',
      'position': i + 1,
      'name': game.title,
      'url': `https://logicpuzzles.ca${game.infoLink || game.link}`,
    })),
  };

  return (
    <div>
      <Helmet>
        <title>Logic Puzzle Games Collection - Free Online Brain Teasers</title>
        <meta name="description" content="Play our complete collection of logic puzzle games! Enjoy Daily Logic Puzzles, Crowns, Binary Sudoku+, Aquarium, Color Flood, Dotstream, and classic Sudoku. Free online brain teasers that challenge your reasoning and problem-solving skills." />
        <link rel="canonical" href="https://logicpuzzles.ca/logic-games" />
        <meta property="og:title" content="Logic Puzzle Games Collection - Free Online Brain Teasers" />
        <meta property="og:description" content="Play our complete collection of logic puzzle games! Free online brain teasers that challenge your reasoning." />
        <meta property="og:url" content="https://logicpuzzles.ca/logic-games" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://logicpuzzles.ca/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Logic Puzzle Games Collection - Free Online Brain Teasers" />
        <meta name="twitter:description" content="Play our complete collection of logic puzzle games! Free online brain teasers that challenge your reasoning." />
        <meta name="twitter:image" content="https://logicpuzzles.ca/og-image.png" />
        <script type="application/ld+json">{JSON.stringify(itemListSchema)}</script>
      </Helmet>
      <NavBar />
      <div className="games-page">
        <div className="container">
          <p className="eyebrow">Logic puzzles</p>
          <h1>Our Logic Games</h1>
          <p className="games-intro">
            Discover our collection of engaging logic puzzles. Each game is carefully crafted to challenge your mind and provide hours of entertainment.
          </p>
          {games.length > 0 ? (
            <div className="games-grid">
              {games.map((game, i) => (
                <GameCard
                  key={game.id}
                  title={game.title}
                  description={game.description}
                  imageUrl={game.imageUrl}
                  link={game.link}
                  infoLink={game.infoLink}
                  loading={i < 6 ? 'eager' : 'lazy'}
                />
              ))}
            </div>
          ) : (
            <p>No logic games available at the moment. Please check back soon!</p>
          )}
          <section className="games-details">
            <h2>How These Logic Puzzles Work</h2>
            <p>
              Logic games are about deduction, not speed. Each puzzle has a clear rule set and a single correct solution.
              You'll use constraints, patterns, and careful reasoning to uncover the right placement on the grid.
            </p>
            <div className="games-details-grid">
              <div>
                <h3>Start with Constraints</h3>
                <p>Look for forced moves and avoid guessing. The best puzzles always have a logical next step.</p>
              </div>
              <div>
                <h3>Work in Layers</h3>
                <p>Small deductions stack into bigger breakthroughs. Keep track of what each clue eliminates.</p>
              </div>
              <div>
                <h3>Use the Notes</h3>
                <p>Marking candidates or possibilities helps reveal contradictions and hidden patterns.</p>
              </div>
            </div>
          </section>
          <section className="games-faq">
            <h2>Logic Games FAQ</h2>
            <div className="games-faq-grid">
              <div>
                <h3>Are these puzzles solvable without guessing?</h3>
                <p>Yes. Our logic puzzles are designed to be solved step-by-step using deduction only.</p>
              </div>
              <div>
                <h3>Do you offer beginner levels?</h3>
                <p>Absolutely. Each game includes easy starters and ramps up to expert challenges.</p>
              </div>
              <div>
                <h3>Can I play on mobile?</h3>
                <p>Yes. All logic games are optimized for touch and run smoothly on phones and tablets.</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default LogicGames;
